import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IAtendente } from 'src/app/interfaces/atendente';
import { OSService } from 'src/app/services';
import { AtendenteService } from 'src/app/services/atendente/atendente.service';

@Component({
  selector: 'app-redirecionar-chamado',
  templateUrl: './redirecionar-chamado.component.html',
  styleUrls: ['./redirecionar-chamado.component.scss']
})
export class RedirecionarChamadoComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  atendentes: IAtendente[];
  redirecionarChamadoForm: FormGroup;
  labelBotao: string = 'Redirecionar';

  constructor(
    private fb: FormBuilder,
    private atendenteService: AtendenteService,
    private osService: OSService
  ) {}

  ngOnInit() {
    this.getAtendentes();
    this.redirecionarChamadoForm = this.fb.group({
      atendente: ['']
    });
  }

  getAtendentes() {
    this.subscriptions$.add(
      this.atendenteService.getAtendente().subscribe({
        next: (response) => {
          this.atendentes = response.data;
        }
      })
    );
  }

  doRedirecionar() {
    const atendenteOs = {
      codigoOS: '000031',
      codAtendente: this.redirecionarChamadoForm.getRawValue().atendente
    };

    this.subscriptions$.add(
      this.osService.postOSAtendente(atendenteOs).subscribe({
        complete: () => {}
      })
    );
  }

  isButtonEnabled(): boolean {
    return !!this.redirecionarChamadoForm.getRawValue().atendente;
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
